var _rect, _circle, _circle2, _rect2, _rect3, _circle3, _rect4, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlider1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 500,
    fill: "#f0f4f8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 100,
    fill: "#ff6b00",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 400,
    r: 150,
    fill: "#ff6b00",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 100,
    width: 300,
    height: 200,
    rx: 10,
    ry: 10,
    fill: "#ff6b00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 120,
    width: 260,
    height: 160,
    rx: 5,
    ry: 5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 250,
    r: 50,
    fill: "#333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 300,
    width: 100,
    height: 150,
    rx: 10,
    ry: 10,
    fill: "#333"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 150,
    fontFamily: "Arial",
    fontSize: 60,
    fontWeight: "bold",
    fill: "#333333"
  }, "Discover the")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 220,
    fontFamily: "Arial",
    fontSize: 60,
    fontWeight: "bold",
    fill: "#ff6b00"
  }, "Oromo Language")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 280,
    fontFamily: "Arial",
    fontSize: 30,
    fill: "#666666"
  }, "Start your journey to fluency today")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider1.557020c625df4b7c7fe7065fa9681be0.svg";
export { ForwardRef as ReactComponent };